let timeLabels = [];
let consoleGroups = [];
let consoleGroupEnumaration = {}
let disableAll = false;
let groupsEnabled = false
export class Timer {
	enabled = true;
	
	constructor(enabled) {
		this.enabled = enabled ?? !disableAll
	}
	time(label) {
		performance.mark(label + '.start');
		if(this.enabled === false) {
			return
		}
		if(!timeLabels.includes(label)) {
			timeLabels.push(label);
		} else {
			console.timeEnd(label);
			console.groupEnd(label);
		}
		startGroup(label);
		//console.time(label);
	}
	timeEnd(label) {
		if(this.enabled === false) {
			return
		}
		if(timeLabels.includes(label)) {
			//console.timeEnd(label);
					performance.mark(label + '.end');
		performance.measure(label, label + '.start', label + '.end');
			timeLabels = timeLabels.filter((l) => l !== label);
			endGroup(label);
		}
	}
	endAllTimeLabels() {
		for(let label of timeLabels) {
			performance.mark(label + '.end');
			performance.measure(label, label + '.start', label + '.end');
			//console.timeEnd(label);
			endGroup(label);
		}
		timeLabels = []
	}
}
function startGroup(label) {
	let groups = label.split('.')
	for(let group of groups) {
		consoleGroupEnumaration[group] = (consoleGroupEnumaration[group] ?? 0) + 1
		if(!consoleGroups.includes(group)) {
			if(groupsEnabled) {
				console.group(group);
			}
			consoleGroups.push(group);
		}
	}
}
function endGroup(label) {
	let groups = label.split('.')
	for(let group of groups) {
		if(consoleGroups.includes(group) ) {
			consoleGroupEnumaration[group] -= 1
			if(consoleGroupEnumaration[group] === 0) {
				if(groupsEnabled) {
					console.groupEnd(group);
				}
				consoleGroups = consoleGroups.filter((g) => g !== group);
			}
		} 
	}
}